import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//Actions
import { GetAllActivities, DelActivity, GetActivityDetails, DeleteRecurrenceActivity, GetActivitiesFilters, DelActivities, DelAllActivities, ExportActivities } from '../../actions/activityAction';
import { GetCategoriesByCommunityId } from '../../actions/categoryActions'

import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { getAllCommunities } from '../../actions/communityActions'


// Components
import { SuperUserDropDown } from '../../components/SuperUserDropDown/SuperUserDropDown';

//Components Material
import AppBar from "@material-ui/core/AppBar";
import { IconButton, InputAdornment, Modal, TextField } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";
import Moment from 'moment';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Button } from "@material-ui/core";

//Constants
import { currentScrollingPage, itemPerPage } from "../../constants/index";

//Views
import AddEditActivityV2 from '../activities/AddEditActivityV2';
import DeleteActivityModal from './DeleteActivityModal';
import CategoriesList from '../categories/CategoriesList';
import AddEditCategory from '../categories/AddEditCategory';
import ActivityFilters from './ActivityFilters';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faTrashAlt, faSortAlphaDown, faSort, faSortNumericDown, faSortAlphaUpAlt, faSortNumericUpAlt } from '@fortawesome/free-solid-svg-icons';
import { UpdateCurrentLocation } from '../../actions/currentUrlActions';

import { DELETE_ACTIVITY_SUCCESS, ADD_ACTIVITY_SUCCESS, UPDATE_ACTIVITY_SUCCESS, DELETE_ACTIVITIES_SUCCESS, DELETE_ALL_ACTIVITIES_SUCCESS } from '../../constants/activitiesConstants';
import ModalMultipleDeleteActivities from './ModalMultipleDeleteActivities';

const initFilters = {
    dateChanged: false,
    dateOptionSelected: '',
    optionInFuture: undefined,
    startDate: new Date(),
    endDate: new Date(),
    categoriesSelected: [],
    registrationsActive: false,
    registrationsOption: 'Greater than',
    greater: 1,
    less: 10,
    unlimitedSeats: false,
    tagsSelected: []
}

const validate = (values) => {
    const errors = {};

    return errors;
};

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


export class Activities extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            currentPage: currentScrollingPage,
            itemPerPage: itemPerPage,
            activitySelected: undefined,
            activityFromLocation: undefined,
            //Activity
            activityExists: false,
            tabSelected: 0,
            //Community
            superUserCommunitySelected: undefined,
            superUserActivitiesLoaddedForCommunity: undefined,
            openCommunityCombo: false,
            //Preview
            openPreview: false,
            tab: 0,
            deleteModal: false,
            activityToDelete: undefined,

            //addCategoryStates
            openCategory: false,
            categorySelected: undefined,
            disableSaveCategory: true,

            disableSaveActivity: false,

            //Filters and search
            selectedActivities: [],
            selectAllButton: false,
            showModalMultipleDelete: false,
            filtersAnchorEl: null,
            filtersObj: { ...initFilters, tagsSelected: [], categoriesSelected: [] },
            filtersApplied: false,

            openSearch: false,
            searchValue: '',

            sortColumn: 'date',
            sortDesc: true
        };
        this.observer = React.createRef();
        this.lastActivityRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }))
                    this.getActivities();
                    if (this.state.selectAllButton)
                        setTimeout(() => { this.SelectAllActivitiesActive(); }, 500);
                }

            });
            if (node) this.observer.current.observe(node)
        }
    };

    componentDidMount() {
        document.title = 'Activities'
        this.InitialLoading();
    };

    InitialLoading = () => {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0))
            this.props.getAllCommunities();

        if (localStorage.getItem('superAdmin') === "false") {

            this.getActivities();

        }

        const id = localStorage.getItem('communityId')
        id && this.props.GetCategoriesByCommunityId(id);

        this.SetHeaderButtons();
    }

    componentWillUnmount() {

        window.removeEventListener("resize", this.resize.bind(this));
        this.props.SetHeaderButtons(undefined)
    }

    SetHeaderButtons = (open = false, tab = 0, openCategory = false) => {
        const headerButtons = this.getHeaderButtons(open, tab, openCategory);
        this.props.SetHeaderButtons(headerButtons)
    }

    getHeaderButtons = (open, tab, openCategory) => {

        const isSuperAdmin = (localStorage.getItem('superAdmin') && (localStorage.getItem('superAdmin') === "true")) ? true : false;
        const communityIdExist = !!(localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0);

        const totalDeleteListActivities = this.state.selectAllButton ? this.props.tableData.totalActivities : this.state.selectedActivities.length;

        return (
            <div className='appbtn-list-engage globalActions'>
                {
                    tab === 0 ?
                        !open ?
                            <Grid item container xs={12} className='appbtn-list-engage globalActions' justify='flex-end' alignItems='center'>
                                {
                                    totalDeleteListActivities > 0 ?
                                        <Grid item
                                            id='Add_Activity_Btn'
                                            className={!communityIdExist ? "disableBottomButon appbtnBarButtonv2" : " appbtnBarButtonv2 redButton"}
                                            disabled={!communityIdExist}
                                            style={{ marginRight: '15px' }}
                                            onClick={this.handleMultipleDelete} >
                                            Delete {totalDeleteListActivities === 1 ? ' Activity' : totalDeleteListActivities + ' Activities'}
                                        </Grid>
                                        :
                                        undefined
                                }
                                {
                                    (
                                        isSuperAdmin &&
                                        totalDeleteListActivities === 0 &&
                                        localStorage.getItem('communityId')
                                    ) ?
                                        <Grid item
                                            id='Export_Activities'
                                            className={!communityIdExist ? "disableBottomButon appbtnBarButtonv2" : " appbtnBarButtonv2 blueButton"}
                                            disabled={!communityIdExist}
                                            style={{ marginRight: '15px' }}
                                            onClick={this.ExportActivitiesOneCommunityHandler} >
                                            Export Activities
                                        </Grid>
                                        :
                                        undefined
                                }
                                <Grid item
                                    id='Add_Activity_Btn'
                                    className={!communityIdExist ? "disableBottomButon appbtnBarButtonv2" : "appbtnBarButtonv2 blueButton"}
                                    disabled={!communityIdExist}
                                    onClick={this.handlerAdd} >
                                    Add Activity
                                </Grid>
                            </Grid>
                            :
                            <div className="appbtn-list-engage globalActions">
                                <Grid id="Activities_save_btn" className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={this.handlerSave}
                                    style={{ opacity: this.state.disableSaveActivity ? '56%' : '100%' }}
                                >
                                    Save
                                </Grid>
                                {
                                    /*
                                    <div className="appbtn-engage redbtn-engage appbtnBarButton" onClick={this.handlerCancel}>
                                    Cancel
                                </div> 
                                    */
                                }
                                {/* <Grid
                                id='Activities_recurrence_btn'
                                className='appbtn-engage purplebtn-engage appbtnBarButton'// {(this.state.activityExists === false) ? 'appbtn-engage disabledPurplebtn-engage ':'appbtn-engage purplebtn-engage'}
                                onClick={this.NewRecurrence} // {this.state.activityExists  === false ? undefined:  this.NewRecurrence}
                                style={this.state.tabSelected !== 0 ? { display: 'none' } : undefined}
                            >
                                Recurrence
                            </Grid> */}
                                {
                                    (this.state.activitySelected) &&
                                    <Grid
                                        id='Activities_delete_btn'
                                        className='appbtn-engage purplebtn-engage appbtnBarButton'// {(this.state.activityExists === false) ? 'appbtn-engage disabledPurplebtn-engage ':'appbtn-engage purplebtn-engage'}
                                        onClick={() => this.handleDelete(undefined, this.state.activitySelected ? this.state.activitySelected : undefined)} // {this.state.activityExists  === false ? undefined:  this.NewRecurrence}
                                        style={this.state.tabSelected !== 0 ? { display: 'none' } : { backgroundColor: '#db5b70' }}
                                    >
                                        Delete
                                    </Grid>
                                }

                            </div>
                        : tab === 1 ?
                            !openCategory ?
                                <Grid item container xs={12} className='appbtn-list-engage globalActions' justify='flex-end' alignItems='center'>
                                    <Grid item
                                        id='Add_Category_Btn'
                                        className={!communityIdExist ? "disableBottomButon appbtnBarButton" : "blueBottomButon appbtnBarButton"}
                                        disabled={!communityIdExist}
                                        onClick={this.handleOpenCategory}
                                    >
                                        Add Category
                                    </Grid>
                                </Grid>
                                :
                                <Grid>
                                    {
                                        this.state.categorySelected ?
                                            <Grid id="Categories_delete_btn" className="appbtn-engage redbtn-engage appbtnBarButton" onClick={this.handleDeleteCategory}>
                                                Delete
                                            </Grid>
                                            :
                                            <Grid id="Categories_cancel_btn" className="appbtn-engage graybtn-engage appbtnBarButton" onClick={this.handleCancelCategory}>
                                                Cancel
                                            </Grid>
                                    }

                                    <Grid id="Categories_save_btn" className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={this.handleSaveCategory}
                                        style={{ opacity: this.state.disableSaveCategory ? '56%' : '100%' }}
                                    >
                                        Save
                                    </Grid>

                                </Grid>


                            :
                            undefined

                }
            </div>

        );
    };

    handleCancelCategory = () => {
        this.setState({ openCategory: false }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory))
        document.title = 'Activities - Categories'

    }

    handleSaveCategory = () => {

        if (this.state.disableSaveCategory) {
            return;
        }

        const link = document.getElementById('save_category_btn');

        if (link) {
            link.click();
        }
    }

    handleOpenCategory = () => {
        this.setState({ openCategory: true, disableSaveCategory: true }, () => this.SetHeaderButtons(false, this.state.tab, this.state.openCategory))
    }

    handleSelectCategory = (cat) => {
        this.setState({ categorySelected: cat, openCategory: true, disableSaveCategory: true }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory))
    }

    enableSaveButton = () => {

        this.setState({ disableSaveCategory: false }, () => this.SetHeaderButtons(false, 1, true))
    }

    disableSaveButton = () => {
        this.setState({ disableSaveCategory: true }, () => this.SetHeaderButtons(false, 1, true))
    }

    enableSaveActivity = () => {

        this.setState({ disableSaveActivity: false }, () => this.SetHeaderButtons(true, 0, false))
    }
    disableSaveActivity = () => {

        this.setState({ disableSaveActivity: true }, () => this.SetHeaderButtons(true, 0, false))
    }

    handleDeleteCategory = () => {

        const link = document.getElementById('delete_category_btn');

        if (link) {
            link.click();
        }

    }

    getActivities = () => {
        const id = localStorage.getItem('communityId')
        if (this.state.filtersApplied) {

            this.props.GetActivitiesFilters(id, this.state.currentPage, this.state.filtersObj, this.state.searchValue, this.state.sortColumn, this.state.sortDesc)

        } else {
            this.props.GetAllActivities(id, this.state.currentPage);
        }
    };

    resize() {
        this.setState({ isMobile: window.innerWidth < 960 });
    };

    //Buttons Handlers
    handlerClose = async (pageNextItem = 0) => {
        document.title = 'Activities'

        this.setState({ open: false, activitySelected: undefined, openPreview: false, openCategory: false, categorySelected: undefined });
        this.SetHeaderButtons(false, this.state.tab, false);

        if (pageNextItem > 0) {
            this.handlePageChange(pageNextItem);
        }

        //Restart activities
        this.setState({ currentPage: 0 },
            () => {
                if (localStorage.getItem('communityId')) {
                    setTimeout(() => { this.getActivities(); }, 300);
                }
            }
        )


    }

    NewRecurrence = () => {
        var link = document.getElementById('new_recurrence_btn')
        link.click()
    };

    handleMultipleDelete = () => {
        this.setState({ showModalMultipleDelete: true });
    }

    handlerAdd = () => {
        this.setState({ open: true, disableSaveActivity: false, activitySelected: undefined }, () => this.SetHeaderButtons(true, this.state.tab, false))
    };

    async handleEdit(e, item) {
        const activitySelected = await this.props.GetActivityDetails(item._id, localStorage.getItem('communityId'))

        if (activitySelected) {

            this.setState({ open: true, activitySelected: activitySelected, disableSaveActivity: true });
            this.SetHeaderButtons(true, this.state.tab, false);
        }
    };

    handleDelete = async (e, data) => {
        if (e) {
            e.stopPropagation();
        }

        if (data) {

            this.setState({ deleteModal: true, activityToDelete: data })
        }
    }

    CancelDelete = () => {
        this.setState({ deleteModal: false, activityToDelete: undefined })

    }
    OnDeleteHandler = () => {
        if (this.state.activityToDelete) {

            this.deleteActivity({}, this.state.activityToDelete)

        }
    }
    OnDeleteRecurrenceHandler = () => {
        if (this.state.activityToDelete) {
            const idCommunity = (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? localStorage.getItem('communityId') : '';

            this.props.DeleteRecurrenceActivity(this.state.activityToDelete, idCommunity);

            this.setState({ open: false, openPreview: false, deleteModal: false, activityToDelete: undefined, activitySelected: false, currentPage: 0 }, () => { this.SetHeaderButtons(false, this.state.tab, false); this.getActivities(); });

        }
    }

    deleteActivity = (event, item, isActive) => {
        const idCommunity = (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? localStorage.getItem('communityId') : '';

        if (item._id && idCommunity) {
            //Call delete Community
            this.props.DelActivity(item, idCommunity);
        }

        this.setState({ open: false, openPreview: false, deleteModal: false, activityToDelete: undefined, activitySelected: false, currentPage: 0 }, () => this.SetHeaderButtons(false, this.state.tab, false));

    };

    handleActivityExist(activityExist) {
        this.setState({ activityExists: activityExist });
    };

    //Hace click en el boton de la pagina AddEditActivity
    handlerCancel = () => {
        var link = document.getElementById('cancel_btn')

        link.click();
        this.setState({ activitySelected: undefined });
        document.title = 'Activities'

    };

    //Hace click en el boton de la pagina AddEditActivity
    handlerSave = () => {

        if (this.state.disableSaveActivity) {
            return;
        }

        var link = document.getElementById('save_btn')
        link.click()
    };

    //#region  PAGINATION
    handlePageChange = (number) => {

        if (number && typeof (number) == 'number' && number > 0) {
            this.setState({
                currentPage: Number(number)
            });
        }

    };

    //#endregion
    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.communityData) {

            communityObj = this.props.communityData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };

    async GetActivityObject(locationActivityId) {
        this.setState({ activitySelected: null })

        const activityObject = await this.props.GetActivityDetails(locationActivityId, localStorage.getItem('communityId'));

        if (activityObject) {
            this.setState({ activitySelected: activityObject, open: true });
            this.SetHeaderButtons(true, this.state.tab);
        }
    };

    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    }
    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    }

    setIdsPaginationHandler = () => {
        try {
            const pagContainer = document.getElementsByClassName('MuiPagination-ul');
            if (pagContainer && pagContainer.length > 0 && pagContainer[0]) {
                const pag = pagContainer[0];
                const liElements = pag.getElementsByTagName('li');
                if (liElements && liElements.length >= 4) {
                    for (let i = 0; i < liElements.length; i++) {
                        liElements[i].removeAttribute('id')
                    }
                    const btn_GoToFist = liElements[0];
                    if (btn_GoToFist) {
                        btn_GoToFist.setAttribute('id', 'pag_btn_gotofirst');
                        btn_GoToFist.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_back = liElements[1];
                    if (btn_back) {
                        btn_back.setAttribute('id', 'pag_btn_goback');
                        btn_back.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_forward = liElements[liElements.length - 2];
                    if (btn_forward) {
                        btn_forward.setAttribute('id', 'pag_btn_goforward');
                        btn_forward.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_GoToLast = liElements[liElements.length - 1];
                    if (btn_GoToLast) {
                        btn_GoToLast.setAttribute('id', 'pag_btn_gotolast');
                        btn_GoToLast.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }

                    for (let i = 2; i < liElements.length - 2; i++) {
                        const btn = liElements[i].getElementsByTagName('button');

                        if (btn && btn.length > 0 && btn[0] && btn[0].textContent.length > 0) {
                            liElements[i].setAttribute('id', `pagElement_${btn[0].textContent}`);
                        }
                    }
                }
            }
        } catch (err) { }
    }

    localStorageRemoveItem = (key) => {
        try {
            if (key) {
                localStorage.removeItem(key);
            }

        } catch (err) { }
    };

    localStorageSetItem = (key, value) => {
        try {
            if (key && value) {
                this.setState({
                    open: false,
                    openCategory: false,
                    tab: 0,
                })
                localStorage.setItem(key, value);
            }

            if (value && value.length > 0) {
                this.props.GetAllActivities(value, this.state.currentPage)
                document.title = 'Activities'
            }
        } catch (err) { }
    };

    setLocalState = (objectToSet) => {
        try {
            this.setState({ ...objectToSet })
        } catch (err) { }
    };

    a11yProps = (index) => {
        return {
            id: `boards-tab-${index}`,
            'aria-controls': `boards-tabpanel-${index}`,
        };
    };


    handleTabChange = (event, newValue) => {
        this.handleChangeIndex(newValue);
    };


    handleChangeIndex = (index) => {

        this.setState({
            tab: index
        });

        this.SetHeaderButtons(false, index, false);
        if (index === 1) {
            this.props.GetCategoriesByCommunityId(localStorage.getItem('communityId'))
            document.title = 'Activities - Categories'
        } else {
            document.title = 'Activities'
        }
    };

    reloadActivitiesImages = () => {
        this.setState({
            filtersObj: { ...initFilters, categoriesSelected: [], tagsSelected: [] },
            currentPage: 0,
            filtersApplied: false,
            searchValue: '',
            openSearch: false,
            sortColumn: 'date',
            sortDesc: true
        })

        const id = localStorage.getItem('communityId');
        this.props.GetCategoriesByCommunityId(id);
    }

    getWithFilters = () => {

        const commId = localStorage.getItem('communityId');

        this.setState({ showModalMultipleDelete: false, selectedActivities: [], selectAllButton: false }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory));

        this.props.GetActivitiesFilters(commId, this.state.currentPage, this.state.filtersObj, this.state.searchValue, this.state.sortColumn, this.state.sortDesc);
    }

    applyFilters = (filters) => {
        this.setState({ filtersObj: filters, currentPage: 0, filtersApplied: true }, () => this.getWithFilters());
        this.setState({ showModalMultipleDelete: false, selectedActivities: [], selectAllButton: false }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory));
    }

    resetFilters = () => {
        this.setState({ showModalMultipleDelete: false, selectedActivities: [], selectAllButton: false }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory));

        this.setState({
            filtersObj: { ...initFilters, categoriesSelected: [], tagsSelected: [] },
            currentPage: 0,
            filtersApplied: false,
            searchValue: '',
            openSearch: false,
            sortColumn: 'date',
            sortDesc: true
        }, () => {
            this.props.GetAllActivities(localStorage.getItem('communityId'), this.state.currentPage);
        })

    }

    handleSearch = () => {
        this.setState({ filtersApplied: true, currentPage: 0 }, () => this.getWithFilters());
        this.setState({ showModalMultipleDelete: false, selectedActivities: [], selectAllButton: false }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory));
    }

    handleResetSearch = () => {
        this.setState({ searchValue: '', openSearch: false, currentPage: 0 }, () => this.getWithFilters())
        this.setState({ showModalMultipleDelete: false, selectedActivities: [], selectAllButton: false }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory));
    }

    handleSort = (column) => {

        const currentColumn = this.state.sortColumn;

        const updState = {
            sortColumn: currentColumn,
            sortDesc: this.state.sortDesc,
            currentPage: 0,
            filtersApplied: true
        }

        switch (column) {
            case 'title':
                if (currentColumn !== column) {
                    updState.sortColumn = 'title'
                    updState.sortDesc = true;
                } else {
                    updState.sortDesc = !this.state.sortDesc
                }
                break;
            case 'date':
                if (currentColumn !== column) {
                    updState.sortColumn = 'date'
                    updState.sortDesc = true;
                } else {
                    updState.sortDesc = !this.state.sortDesc
                }
                break;
            case 'category':
                if (currentColumn !== column) {
                    updState.sortColumn = 'category'
                    updState.sortDesc = true;
                } else {
                    updState.sortDesc = !this.state.sortDesc
                }
                break;
            case 'registrations':
                if (currentColumn !== column) {
                    updState.sortColumn = 'registrations'
                    updState.sortDesc = true;
                } else {
                    updState.sortDesc = !this.state.sortDesc
                }
                break;
            default:
                break;
        }

        this.setState(updState, () => this.getWithFilters())

    }

    ToogleCheckBoxHandler = (activity) => {
        if (this.state.selectedActivities) {
            const arrayActivitiesSelected = this.state.selectedActivities;

            const item = arrayActivitiesSelected.find(item => item._id === activity._id);

            if (!item) {
                arrayActivitiesSelected.push(activity);

                if (arrayActivitiesSelected.length === this.props.tableData.length)
                    this.setState({ selectAllButton: true });
            }
            else {
                const indexToDelete = arrayActivitiesSelected.map(item => item._id).indexOf(activity._id);
                arrayActivitiesSelected.splice(indexToDelete, 1);
                this.setState({ selectAllButton: false });
            }
            this.setState({ selectedActivities: arrayActivitiesSelected });
            this.SetHeaderButtons();
        }
    };

    SelectAllActivitiesHandler = (e) => {
        const selectAllButton = !this.state.selectAllButton;
        let arrayActivitiesSelected = this.state.selectedActivities ? this.state.selectedActivities : [];

        const activitiesArray = this.props.tableData ? this.props.tableData.data : [];
        if (activitiesArray.length > 0)
            if (selectAllButton === true) {
                if (activitiesArray) {
                    activitiesArray.forEach(item => {
                        const indexOfItemAllReadySelected = (this.state.selectedActivities) ? this.state.selectedActivities.map(item => item._id).indexOf(item._id) : -1;

                        if (indexOfItemAllReadySelected === -1) {

                            arrayActivitiesSelected.push(item);
                        }
                    }
                    );
                }
            }
            else {
                if (activitiesArray) {
                    activitiesArray.forEach(item => {

                        if (this.state.selectedActivities) {
                            const indexToDelete = this.state.selectedActivities.map(item => item._id).indexOf(item._id);

                            if (indexToDelete !== -1) {

                                arrayActivitiesSelected.splice(indexToDelete, 1);
                            }
                        }
                    });
                }
            }
        this.setState({ selectedActivities: arrayActivitiesSelected, selectAllButton: selectAllButton }, () => this.SetHeaderButtons());
    };

    SelectAllActivitiesActive = () => {
        const activitiesArray = this.props.tableData ? this.props.tableData.data : [];
        let arrayActivitiesSelected = this.state.selectedActivities ? this.state.selectedActivities : [];
        if (activitiesArray.length > 0)
            if (activitiesArray) {
                activitiesArray.forEach(item => {
                    const indexOfItemAllReadySelected = (this.state.selectedActivities) ? this.state.selectedActivities.map(item => item._id).indexOf(item._id) : -1;

                    if (indexOfItemAllReadySelected === -1) {

                        arrayActivitiesSelected.push(item);
                    }
                }
                );
            }

        this.setState({ selectedActivities: arrayActivitiesSelected });
    }

    OnCancelHandler = () => {
        this.setState({ showModalMultipleDelete: false });
    };

    OnDeleteMultipleHandler = async () => {
        const activitiesIds = [];
        this.state.selectedActivities.forEach(act => activitiesIds.push(act._id));

        if (this.state.selectAllButton)
            await this.props.DelAllActivities(localStorage.getItem('communityId'), this.state.filtersObj, this.state.searchValue);
        else
            await this.props.DelActivities(activitiesIds.join(','));

        this.setState({ showModalMultipleDelete: false, selectedActivities: [], selectAllButton: false }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory));
    }

    ExportActivitiesOneCommunityHandler = () => {
        try {
            const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

            const communityFound = (this.props.communityData && this.props.communityData.length > 0) ? this.props.communityData.find(a => String(a.communityId) === String(communityId)) : undefined;

            if (this.props.ExportActivities && communityId) {
                const communityName = (communityFound && communityFound.name) ? communityFound.name : ''
                this.props.ExportActivities(communityId, communityName)
            }
        } catch (err) {
            return undefined
        }
    }

    render() {

        const shouldReturnToHome = (this.props.returnToHome && this.props.returnToHome === 'true') ? true : false;
        if (this.props.UpdateCurrentLocation && shouldReturnToHome) {

            this.setState(
                {
                    open: false,
                    openCategory: false,
                    tab: 0,
                },
                () => {
                    this.InitialLoading();
                    this.props.UpdateCurrentLocation('false');
                })
        }


        //Set IDS PAGINATION
        setTimeout(() => {
            this.setIdsPaginationHandler();
        }, 100);

        if (this.props.activityReducerType === DELETE_ACTIVITY_SUCCESS || this.props.activityReducerType === ADD_ACTIVITY_SUCCESS || this.props.activityReducerType === UPDATE_ACTIVITY_SUCCESS
            || this.props.activityReducerType === DELETE_ALL_ACTIVITIES_SUCCESS || this.props.activityReducerType === DELETE_ACTIVITIES_SUCCESS) {
            this.setState({ currentPage: 0 }, () => this.getActivities());
        }


        const displayHeaders = this.state.isMobile ? 'none' : undefined;

        const locationActivityId = (this.props.location && this.props.location.state && this.props.location.state.activityId) ? this.props.location.state.activityId : undefined;
        const activityObject = (this.props.location && this.props.location.state && this.props.location.state.activityObject) ? this.props.location.state.activityObject : undefined;
        if (this.state.activitySelected === undefined && this.state.open === false && activityObject && !this.state.activityFromLocation) {
            this.setState({
                open: true, activitySelected: Object.keys(activityObject).length === 0 ? undefined : activityObject,
                activityFromLocation: activityObject
            }, () => this.SetHeaderButtons(true, this.state.tab, false))
        }

        if (locationActivityId && locationActivityId.length > 0 && this.state.activitySelected === undefined) {
            this.GetActivityObject(locationActivityId);
        }

        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;


        if (isSuperAdmin
            && this.props.communityData
            && this.props.communityData.length > 0
            && localStorage.getItem('communityId')
            && localStorage.getItem('communityId').length > 0
            && this.state.superUserCommunitySelected === undefined
        ) {

            this.setState({ superUserCommunitySelected: this.GetCommunityObjectForSupuerUserCombo(localStorage.getItem('communityId')) }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory));

        }

        if (
            (
                this.state.superUserCommunitySelected &&
                (
                    !this.state.superUserActivitiesLoaddedForCommunity ||
                    (this.state.superUserActivitiesLoaddedForCommunity !== this.state.superUserCommunitySelected)
                )
            ) ||
            (
                this.state.superUserCommunitySelected === undefined &&
                this.state.superUserActivitiesLoaddedForCommunity !== undefined
            )
        ) {
            this.getActivities();
            this.setState({
                superUserActivitiesLoaddedForCommunity: this.state.superUserCommunitySelected,
                showModalMultipleDelete: false, selectedActivities: [], selectAllButton: false
            }, () => this.SetHeaderButtons(this.state.open, this.state.tab, this.state.openCategory));

        }

        const disabledButton = false;

        const currentPage = this.state.currentPage;
        const itemPerPage = this.state.itemPerPage;

        const totalItems = this.props.tableData ? this.props.tableData.totalActivities : 0;
        const lastPage = Math.ceil(totalItems / itemPerPage);
        const pageNextItem = totalItems % itemPerPage === 0 ? lastPage + 1 : lastPage;

        const currentData = this.props.tableData ? this.props.tableData.data : [];
        const totalCategories = this.props.categoryData ? this.props.categoryData.length : 0

        //ThumbnailImage
        const ThumbnailImage = (
            {
                height = '70px',
                width = '110px',
                alt,
                url
            }
        ) => {
            return (
                <img
                    alt={'Thumbnail ' + alt}
                    style={{ borderRadius: '10px', margin: (this.state.isMobile) ? 'auto' : '', maxWidth: '100%', objectFit: 'cover' }}
                    width={width}
                    height={height}
                    src={url}
                >
                </img>
            );
        };

        return (
            <React.Fragment>
                <AppBar position="static" className="dark">
                    <Toolbar >
                        <Grid container >
                            <Grid item container xs={!this.state.open ? 4 : 12} sm={6} md={6} lg={6} alignContent='center' justify='flex-start'>
                                {
                                    this.state.open ?
                                        <Typography variant="h6"  >
                                            <div id='Activities_back_btn' className="engage-nav ToolbalCommunityName" onClick={this.handlerCancel}>
                                                <img
                                                    src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                    alt='return'
                                                    className="returnIcon"
                                                />
                                                {
                                                    (this.state.superUserCommunitySelected && this.state.superUserCommunitySelected.name) ? this.state.superUserCommunitySelected.name + ' Activities' : 'Activities'
                                                }
                                            </div>
                                        </Typography>
                                        :
                                        this.state.openCategory ?
                                            <Typography variant="h6"  >
                                                <div id='Categories_back_btn' className="engage-nav ToolbalCommunityName" onClick={() => {
                                                    this.setState({ openCategory: false, categorySelected: undefined }, () => this.SetHeaderButtons(false, this.state.tab, this.state.openCategory))
                                                    document.title = 'Activities - Categories'

                                                }}>
                                                    <img
                                                        src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                        alt='return'
                                                        className="returnIcon"
                                                    />
                                                    All Categories
                                                </div>
                                            </Typography>
                                            :
                                            undefined
                                }
                            </Grid>
                            <Grid item container xs={8} sm={6} md={6} lg={6} className="globalActions" alignItems='center' justify='flex-end' >
                                {

                                    !this.state.open && !this.state.openCategory ?
                                        <Grid item container className='appbtn-list-engage globalActions' justify='flex-end' alignItems='center'>
                                            {
                                                (isSuperAdmin && isSuperAdmin === true) ?
                                                    <Grid item container xs={12} style={{ paddingLeft: '15px', marginRight: '15px', }} justify='center' alignContent='center' >
                                                        <SuperUserDropDown
                                                            stateOpen={this.state.open}
                                                            localStorageSetItem={this.localStorageSetItem}
                                                            localStorageRemoveItem={this.localStorageRemoveItem}
                                                            SetHeaderButtons={this.SetHeaderButtons}
                                                            handleCommunityCombo={this.handleCommunityCombo}
                                                            setState={this.setLocalState}
                                                            communityData={this.props.communityData ? this.props.communityData : []}
                                                            superUserCommunitySelected={this.state.superUserCommunitySelected ? this.state.superUserCommunitySelected : {}}
                                                            openCommunityCombo={this.state.openCommunityCombo}
                                                            handleCommunityOnBlur={this.handleCommunityOnBlur}
                                                            dispatchActions={this.reloadActivitiesImages}
                                                        />
                                                    </Grid>
                                                    :
                                                    undefined

                                            }
                                        </Grid>
                                        // : this.state.open && !this.state.openCategory?
                                        // <Grid item xs={12} sm={5} md={5} lg={4}>
                                        //     <Field
                                        //         labelInLeft={true}
                                        //         name="ViewPreview"
                                        //         label="Show Previews"
                                        //         checked={this.state.openPreview}
                                        //         onClick={() => this.setState((prevState) => ({ openPreview: !prevState.openPreview }))}
                                        //         component={renderSwitchWithLabel}
                                        //         stylesLabel={{ fontWeight: 'bold', textAlign: 'left', fontSize: '14px', color: '#F0EFEF', }}
                                        //         idToSet='Activities_show_preview_switch'
                                        //     />
                                        // </Grid>
                                        :
                                        undefined
                                }
                            </Grid>
                        </Grid>

                    </Toolbar>
                </AppBar>
                <main style={{ flexGrow: '1', padding: '0px', zIndex: '1300' }}>
                    <div>
                        {
                            this.state.open ?
                                <div>
                                    <AddEditActivityV2
                                        openPreview={this.state.openPreview ? this.state.openPreview : false}
                                        closeDialog={this.handlerClose}
                                        data={this.state.activitySelected ? this.state.activitySelected : undefined}
                                        tzName={this.props.currentCommunity?.timeZoneName}
                                        newItemPage={pageNextItem}
                                        currentPage={currentPage}
                                        itemPerPage={itemPerPage}
                                        handleActivityExist={this.handleActivityExist.bind(this)}
                                        activityExists={this.state.activityExists}
                                        handleTabSelectedChange={(tab = 0) => { this.setState({ tabSelected: tab }); }}
                                        tabSelected={this.state.tabSelected}
                                        buttonState={this.state.disableSaveActivity}
                                        enableButton={this.enableSaveActivity}
                                        disableButton={this.disableSaveActivity}
                                    />
                                </div>
                                :
                                this.state.openCategory ?
                                    <AddEditCategory
                                        close={() => {
                                            this.setState({ openCategory: false, categorySelected: undefined }, this.SetHeaderButtons(this.state.open, this.state.tab, false))
                                            document.title = 'Activities - Categories'
                                        }}
                                        data={this.state.categorySelected}
                                        enableButton={this.enableSaveButton}
                                        disableButton={this.disableSaveButton}
                                        buttonState={this.state.disableSaveCategory}
                                    />
                                    :
                                    <>
                                        <Tabs
                                            value={this.state.tab}
                                            onChange={this.handleTabChange}
                                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                            variant="fullWidth"
                                            aria-label="full width tabs activity"
                                            style={{ width: '100%', backgroundColor: '#1f1f1f' }}
                                        >
                                            <Tab label={`Activities (${totalItems})`} className={(this.state.tab === 0) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                            <Tab label={`Categories (${totalCategories})`} className={(this.state.tab === 1) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                        </Tabs>

                                        <Grid container xs={12}>
                                            <SwipeableViews
                                                axis={'x'}
                                                index={this.state.tab}
                                                onChangeIndex={this.handleChangeIndex}
                                                className="swipeableViews"
                                            >
                                                <TabPanel value={0} index={0} dir={'x'}  >

                                                    {/* Activities list */}
                                                    <Grid container >
                                                        {/* Selected All Button and selected item counter */}
                                                        <Grid item container xs={4} justifyContent='flex-start' alignItems='center'>
                                                            <Button id='addEditDevice_Headers_SelectAll' className="selectAllButtonv2" onClick={() => this.SelectAllActivitiesHandler()}>
                                                                Select All
                                                            </Button>
                                                            <span className="selectAllQtyMessagev2" style={{ marginLeft: '16px' }}>
                                                                {
                                                                    this.state.selectAllButton ?
                                                                        `${totalItems} Selected`
                                                                        :
                                                                        this.state.selectedActivities.length > 0 ?
                                                                            `${this.state.selectedActivities.length} Selected`
                                                                            :
                                                                            ''
                                                                }
                                                            </span>
                                                        </Grid>
                                                        {/* Search and filters menu */}
                                                        <Grid item container xs={8} justifyContent='flex-end' alignItems='center'>
                                                            {
                                                                this.state.openSearch ?
                                                                    <Grid item container xs={10} sm={10} md={6} lg={4} style={{ marginBottom: '1rem' }}>
                                                                        <TextField
                                                                            id='activity_search'
                                                                            item
                                                                            name='Search'
                                                                            placeholder="Enter search term(s) and press Enter"
                                                                            value={this.state.searchValue}
                                                                            fullWidth
                                                                            InputProps={{
                                                                                disableUnderline: true,
                                                                                startAdornment: (
                                                                                    <InputAdornment position="start">
                                                                                        <img
                                                                                            src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                                                                            alt='search_icon'
                                                                                            width='32px'
                                                                                            heigth='32px'
                                                                                        />
                                                                                    </InputAdornment>
                                                                                ),
                                                                                endAdornment: (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton id='activities_clear_btn' onClick={this.handleResetSearch}>
                                                                                            <FontAwesomeIcon icon={faTimesCircle} color='white' size='sm' />
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                )
                                                                            }}
                                                                            className="activities_search animate__animated animate__slideInRight"
                                                                            onChange={(e) => this.setState({ searchValue: e.target.value })}
                                                                            onKeyDown={(e) => { if (e && e.keyCode === 13) this.handleSearch() }}
                                                                        />

                                                                    </Grid>
                                                                    :
                                                                    <IconButton item onClick={() => this.setState({ openSearch: true })} id='search_btn'>
                                                                        <img
                                                                            src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                                                            alt='search_icon'
                                                                            width='30px'
                                                                            heigth='30px'
                                                                        />
                                                                    </IconButton>

                                                            }

                                                            <IconButton item onClick={(e) => this.setState({ filtersAnchorEl: e.currentTarget })} id='filters_btn'>
                                                                <img
                                                                    src='https://engage360.s3.amazonaws.com/Icons/Categories/filter.svg'
                                                                    alt='filters_icon'
                                                                    width='30px'
                                                                    heigth='30px'
                                                                />
                                                            </IconButton>

                                                        </Grid>

                                                        {/* Activity titles */}
                                                        <Grid container alignItems='center' className="titleEngageStyleHeadersBook" style={{ display: displayHeaders, padding: '0px 10px' }} >
                                                            <Grid item md={1} lg={1}></Grid>
                                                            <Grid item md={2} lg={1}>Image</Grid>
                                                            <Grid item md={3} lg={3} style={{ paddingLeft: (window.innerWidth >= 1280 && window.innerWidth < 1600) ? '10px' : '0px' }}>
                                                                Activity
                                                                <IconButton onClick={() => this.handleSort('title')}>
                                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'title' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'title' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'title') ? faSort : null} color='#a2a1a2' />
                                                                </IconButton>
                                                            </Grid>
                                                            <Grid item md={2} lg={2}>
                                                                Category
                                                                <IconButton onClick={() => this.handleSort('category')}>
                                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'category' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'category' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'category') ? faSort : null} color='#a2a1a2' />
                                                                </IconButton>
                                                            </Grid>
                                                            <Grid item md={2} lg={3}>
                                                                Date
                                                                <IconButton onClick={() => this.handleSort('date')}>
                                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'date' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'date' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'date') ? faSort : null} color='#a2a1a2' />
                                                                </IconButton>
                                                            </Grid>
                                                            <Grid item md={2} lg={2} style={{ textAlign: (window.innerWidth < 1400) ? 'center' : 'left' }}>
                                                                Registrations
                                                                <IconButton onClick={() => this.handleSort('registrations')}>
                                                                    <FontAwesomeIcon icon={(this.state.sortColumn === 'registrations' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'registrations' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'registrations') ? faSort : null} color='#a2a1a2' />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container>
                                                            {
                                                                currentData && currentData.map((item, index) => {

                                                                    const startDateObj = item.date ? new Date(new Date(item.date).toLocaleString("en-US", { timeZone: this.props.currentCommunity?.timeZoneName })) : undefined;
                                                                    const endDateObj = item.endDate ? new Date(new Date(item.endDate).toLocaleString("en-US", { timeZone: this.props.currentCommunity?.timeZoneName })) : undefined;

                                                                    //For residents de-register 
                                                                    let attendees = (item.attendees) ? item.attendees.length : 0;

                                                                    if (attendees > 0) {
                                                                        item.attendees.forEach(item => {
                                                                            if (item.subscribed === false)
                                                                                attendees--;
                                                                        })
                                                                    }

                                                                    return (
                                                                        <Grid ref={(currentData.length === index + 1) ? this.lastActivityRef : undefined} id={`Activity_row_${item._id}`} container key={item._id} alignItems='center' justify='flex-start'
                                                                            className={this.state.isMobile ? "activityTitle-engage rowEngageStyleList" : "rowEngageStyleList"} onClick={(e) => { this.handleEdit(e, item); }} style={{ padding: '0px 10px', color: '#F0EFEF' }}
                                                                        >
                                                                            <Grid id={`activityRow_checkbox`} item xs={12} sm={12} md={1} lg={1} className="rowEngageStyle ">
                                                                                <Checkbox
                                                                                    id={`device_checkbox_${item._id}`}
                                                                                    checked={this.state.selectedActivities && this.state.selectedActivities.length > 0 ? this.state.selectedActivities.find(activity => activity._id === item._id) !== undefined ? true : false : false}
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                    onChange={() => this.ToogleCheckBoxHandler(item)}
                                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                                                                    checkedIcon={
                                                                                        <CheckBoxIcon fontSize="large" />
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                            <Grid id={`activityRow_thumbnail`} item container xs={12} sm={12} md={2} lg={1} style={{ display: 'flex' }} ><ThumbnailImage alt={index} url={item.thumbnailImageUrl ? item.thumbnailImageUrl : (item.backgroundUrl ? item.backgroundUrl : '')} /></Grid>
                                                                            <Grid id={`activityRow_title`} item xs={12} sm={12} md={3} className="rowEngageStyle "
                                                                                style={{ paddingLeft: (window.innerWidth >= 1280 && window.innerWidth < 1600) ? '10px' : '0px' }}>
                                                                                {item.title ? item.title : 'no title'}
                                                                            </Grid>
                                                                            <Grid id={`activityRow_category`} item xs={12} sm={12} md={2} className="rowEngageStyle ">{(item.category && item.category.name) ? item.category.name : 'no category'}</Grid>
                                                                            <Grid id={`activityRow_date`} item xs={12} sm={12} md={2} lg={3} className="rowEngageStyle" >
                                                                                <Grid className="rowEngageStyle">{Moment(startDateObj).format("MMM DD, YYYY")}</Grid>
                                                                                <Grid className="rowEngageStyle">{`${Moment(startDateObj).format('LT')} - ${Moment(endDateObj).format('LT')}`}</Grid>
                                                                            </Grid>
                                                                            <Grid id={`activityRow_attendees`} item xs={12} sm={12} md={1} lg={1} className="rowEngageStyle" style={{ textAlign: (window.innerWidth < 1400) ? 'center' : 'left' }}>
                                                                                {`${attendees}/${(item.maxAttendees ? item.maxAttendees : 'unlimited')}`}
                                                                            </Grid>
                                                                            <Grid id={`activityRow_actions`} item xs={12} sm={12} md={1}
                                                                                className='EngageButonClass'
                                                                                style={{ textAlign: 'rigth', alignContent: 'center', display: 'flex', justifyContent: 'center' }}
                                                                            >
                                                                                <IconButton
                                                                                    id={`Activity_row_delete_btn_${item._id}`}
                                                                                    value={item._id}
                                                                                    className="transparentButtom"
                                                                                    disabled={disabledButton}
                                                                                    onClick={(e) => {
                                                                                        this.handleDelete(e, item);
                                                                                    }}>
                                                                                    <FontAwesomeIcon
                                                                                        icon={faTrashAlt}
                                                                                        color='#c43740'
                                                                                        size='1x'
                                                                                    />
                                                                                    {/* <TrashAlt className="iconDeleteListIcon"  /> */}
                                                                                </IconButton>
                                                                            </Grid>
                                                                        </Grid>
                                                                    )
                                                                })
                                                            }
                                                        </Grid>
                                                    </Grid>

                                                </TabPanel>

                                                <TabPanel value={1} index={1} dir={'x'}>
                                                    <Grid item container xs={12} justify='center'>
                                                        <CategoriesList
                                                            onSelectCategory={this.handleSelectCategory}
                                                        />

                                                    </Grid>

                                                </TabPanel>



                                            </SwipeableViews>

                                        </Grid>

                                    </>
                        }

                        <Modal
                            open={this.state.deleteModal}
                            onClose={this.CancelDelete}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ borderRadius: '16px' }}
                        >
                            <DeleteActivityModal
                                activity={this.state.activityToDelete ? this.state.activityToDelete : null}
                                timeZoneName={this.props.currentCommunity ? this.props.currentCommunity.timeZoneName : undefined}
                                OnCancelHandler={this.CancelDelete}
                                OnDeleteHandler={this.OnDeleteHandler}
                                OnDeleteRecurrenceHandler={this.OnDeleteRecurrenceHandler}
                            />
                        </Modal>
                        <Modal
                            open={this.state.showModalMultipleDelete}
                            onClose={() => this.setState({ showModalMultipleDelete: false })}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ borderRadius: '16px' }}
                        >
                            <ModalMultipleDeleteActivities
                                OnCancelHandler={this.OnCancelHandler}
                                OnDeleteMultipleHandler={this.OnDeleteMultipleHandler}
                                selectedActivities={this.state.selectedActivities}
                                totalActivities={this.state.selectAllButton ? this.props.tableData.totalActivities : this.state.selectedActivities.length}
                            />
                        </Modal>
                        {
                            this.state.filtersAnchorEl &&
                            <ActivityFilters
                                anchorEl={this.state.filtersAnchorEl}
                                onClose={() => this.setState({ filtersAnchorEl: null })}
                                filters={this.state.filtersObj}
                                applyFilters={this.applyFilters}
                                resetFilters={this.resetFilters}
                            />
                        }
                    </div>
                </main>
            </React.Fragment>
        );
    }
};


function mapStateToProps(state) {
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId, timeZoneName: item.timeZoneName })) : [];
    const activitiesData = (state.activityReducer && state.activityReducer.activityData) ? state.activityReducer.activityData : [];
    const categoryData = (state.categoryReducer && state.categoryReducer.categoryData) ? state.categoryReducer.categoryData : [];
    let returnToHome = (state && state.currentUrlReducer && state.currentUrlReducer.returnToHome) ? state.currentUrlReducer.returnToHome : 'false'

    const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
    const currentCommunity = (communityId) ? communityData.find(item => item.communityId === communityId) : undefined;

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        tableData: activitiesData,
        communityData: communityData,
        currentCommunity: currentCommunity,
        categoryData,
        activityReducerType: (state.activityReducer && state.activityReducer.type) ? state.activityReducer.type : "",
        returnToHome: returnToHome,
    }
};

export default connect(mapStateToProps, { GetAllActivities, DelActivity, GetActivityDetails, SetHeaderButtons, getAllCommunities, DeleteRecurrenceActivity, GetCategoriesByCommunityId, UpdateCurrentLocation, GetActivitiesFilters, DelActivities, DelAllActivities, ExportActivities })
    (reduxForm({
        form: 'ActivityListForm',
        validate,
        enableReinitialize: true,
    })(Activities));
